module.exports = __webpack_public_path__ + "static/media/planEmerg_4.a7e3d7cc.png";